"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stripPropertiesWithValue;

var _filterObject = _interopRequireDefault(require("./filter-object"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function stripPropertiesWithValue(object, valueToStrip) {
  return (0, _filterObject["default"])(object, function (_key, value) {
    return value !== valueToStrip;
  });
}